

import { NgModule } from '@angular/core';
import { TemplateInstanceModule } from 'tnx-admin-service/templateinstance';
import { TnxSharedModule } from 'tnx-shared';
import { ExcelFormComponent } from './excel-form/excel-form.component';
import { ExcelComponent } from './excel.component';
import { ExcelRoutes } from './excel.routing';

export function declaration() {
    return [ExcelComponent, ExcelFormComponent];
}

@NgModule({
    imports: [
        TnxSharedModule,
        TemplateInstanceModule
    ],
    declarations: declaration(),
    exports: declaration()
})
export class ExcelModule {
}

@NgModule({
    imports: [ExcelModule, ExcelRoutes],
    exports: [ExcelModule]
})
export class ExcelWithRouteModule {
}
